<aw-modal #modal [size]="Size.s" [showCloseButton]="true">
  <figure class="image aw-2-txt--center">🫠</figure>

  <div class="aw-2-txt--center">
    <h1 class="aw-2-mb--l">{{ translations.title }}</h1>

    <div>
      <p class="subtitle">{{ translations.subtitle }}</p>
      <p>{{ translations.subtitle2 }}</p>

      @if (eventId()) {
        @if (!showDetails()) {
          <aw-link-button class=" aw-2-d--block aw-2-mt--l" [text]="translations.showDetails" (onClick)="showDetails.set(true)" />
        }

        @else {
          <div class="aw-2-mt--l">
            <pre>Event ID: {{ eventId() }}</pre>
          </div>
        }
      }
    </div>
  </div>

  <div modal-footer class="footer">
    @if (error()) {
      <aw-button
        [size]="Size.m"
        [color]="Color.Main"
        [type]="'secondary'"
        [text]="translations.contactSupport"
        (onClick)="onContactSupportClick()"
      />
    }

    <div class="footer-right">
      <aw-button
        [size]="Size.m"
        [color]="Color.Main"
        [type]="'tertiary'"
        [text]="translations.close"
        (onClick)="hide()"
      />

      <aw-button
        [size]="Size.m"
        [color]="Color.Main"
        [type]="'primary'"
        [text]="translations.reload"
        (onClick)="reload()"
      />
    </div>
  </div>
</aw-modal>
